import React, { useCallback, useEffect, useRef } from 'react';

import * as Styled from './LandingScreen.styles';
import { fadeMotionProps } from 'utils/styles/animations';
// import { SOUND_LABELS } from 'data/sound';
import useGlobalStore from 'utils/store';
// import { SoundController } from 'webgl/controllers/SoundController';
// import { ReactComponent as HandIcon } from "../../svg/hand-icon.svg";
import { isDesktop } from 'utils/platform';
import { useSwipeable } from 'react-swipeable';
import { APP_EVENTS, EventsManager } from 'webgl/events/EventsManager';
import { ScenesManager } from 'webgl/scenes/ScenesManager';

import HandIconImage from 'assets/img/mouse-icon.png';
import { SoundController } from 'webgl/controllers/SoundController';
import { SOUND_LABELS } from 'data/sound';

export interface LandingScreenProps {
  onCompleteLoad: () => void;
}

const LandingScreen: React.FC<LandingScreenProps> = ({
  onCompleteLoad,
}) => {
  const { copy } = useGlobalStore();
  const swipeEnabled = useRef<boolean>(false);
  const scrollTimerRef = useRef<ReturnType<typeof setTimeout>>();

  const goToHome = useCallback(() => {
    SoundController.playAudio(SOUND_LABELS.MAIN);
    EventsManager.instance.trigger(APP_EVENTS.OUTLINE_SHOW);
    onCompleteLoad();
  }, [onCompleteLoad]);

   const onWheel = useCallback(
     (event: { preventDefault: () => void; deltaY: number }) => {
       event.preventDefault();
       clearTimeout(scrollTimerRef.current);
       scrollTimerRef.current = setTimeout(() => {
         clearTimeout(scrollTimerRef.current);
         goToHome();
       }, 500);
     },
     [goToHome]
   );

   const handlers = useSwipeable({
     onSwiped: (eventData) => {
       if (!swipeEnabled.current) return;
      //  goToHome();
     },
     ...{
       trackMouse: true,
     },
   });

   useEffect(() => {
       swipeEnabled.current = true;

      //  if (isDesktop()) {
      //    window.addEventListener("wheel", onWheel);
      //  }

        if (ScenesManager.debugMode) {
          goToHome();
        }

     return () => {
       swipeEnabled.current = false;
      //  window.removeEventListener("wheel", onWheel);
     };
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

  return (
    <Styled.Wrapper {...fadeMotionProps}>
      <Styled.Content {...handlers}>




        
        {/* <Styled.SoundText
          {...fadeMotionProps}
          transition={{
            duration: 0.6,
            delay: 0,
          }}
          dangerouslySetInnerHTML={{ __html: copy.loadingScreen.disclaimer }}
        /> */}
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export default LandingScreen;
